import { PRINT_SELECTION_VERSION } from "./printSelectionSlice";

// A prepared selection survives a refresh of this tab (sessionStorage), scoped
// to company + user + schema version. It never reappears days later in another
// tab the way localStorage would, and it is revalidated against the server
// after loading.

const keyFor = ({ companyId, userId }) =>
  companyId && userId ? `bw-print-selection-v${PRINT_SELECTION_VERSION}:${companyId}:${userId}` : null;

const getStorage = () => {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch (_error) {
    return null;
  }
};

export const loadStoredSelection = (scope, storage = getStorage()) => {
  const key = keyFor(scope);
  if (!key || !storage) return null;
  try {
    const parsed = JSON.parse(storage.getItem(key) || "null");
    return parsed && parsed.version === PRINT_SELECTION_VERSION ? parsed : null;
  } catch (_error) {
    return null;
  }
};

export const saveStoredSelection = (scope, selection, storage = getStorage()) => {
  const key = keyFor(scope);
  if (!key || !storage) return;
  try {
    if (!selection.order.length) {
      storage.removeItem(key);
      return;
    }
    storage.setItem(
      key,
      JSON.stringify({
        version: selection.version,
        entries: selection.entries,
        order: selection.order,
        updatedAt: selection.updatedAt,
      })
    );
  } catch (_error) {}
};
